/*
    Add here your own custom javascript
*/
/* 
   Add here your own custom javascript
*/

// Scroll al formulario de producto al hacer click en "Consultar Disponibilidad"
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a, button').forEach(function(el) {
    if (el.textContent.trim().toLowerCase().includes('consultar disponibilidad')) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector('product-form, #product-form, form[action*="/cart/add"]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  });
});
